import { useMemo } from 'react';

import { useEligibleServicesModalStore } from '../stores/useEligibleServicesModal.store';

import useEligibleServices from './useEligibleServices';

const useEligibleServicesLine = (policyId?: number | string) => {
  const { data, isLoading } = useEligibleServices(policyId);
  const handleOpenModal = useEligibleServicesModalStore((state) => state.handleChangeVisibility);

  const displayLabel = useMemo(() => {
    const label = data.serviceNames.slice(0, 3).join(', ');

    return data.extraCount > 0 ? `${label},…` : label;
  }, [data.serviceNames, data.extraCount]);

  return {
    displayLabel,
    categories: data.categories,
    extraCount: data.extraCount,
    total: data.total,
    isLoading,
    handleOpenModal: () => handleOpenModal(true),
  };
};

export default useEligibleServicesLine;
